export const SERVICE_NAME = 'МТС Оплата'
export const SERVICE_TITLE = 'Оплата игровых кошельков: пополнение аккаунтов онлайн банковской картой'
export const SERVICE_DESCRIPTION =
  'Пополнение игровых кошельков ⏩ Онлайн оплата подписки банковской картой ⏩ Удобный сервис для быстрых переводов и платежей'
